import { QueryClient } from "@tanstack/react-query";

/**
 * Configuração centralizada do QueryClient
 *
 * Define valores padrão para todas as queries e mutations do React Query.
 * Hooks individuais podem sobrescrever essas opções quando necessário.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Tempo que os dados são considerados "frescos" (não faz refetch automático)
      staleTime: 2 * 60 * 1000, // 2 minutos

      // Tempo que os dados ficam em cache após não serem mais usados
      gcTime: 5 * 60 * 1000, // 5 minutos (antigo cacheTime)

      // Número de tentativas em caso de erro
      retry: 2,

      // Delay entre tentativas (exponencial backoff)
      // Primeira tentativa: 1s, segunda: 2s, terceira: 4s (máximo 30s)
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),

      // Refetch quando a janela ganha foco (útil para sincronizar dados)
      refetchOnWindowFocus: true,

      // Refetch quando reconecta à internet
      refetchOnReconnect: true,

      // Refetch ao montar o componente (pode ser sobrescrito por hooks específicos)
      refetchOnMount: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
